<template>
  <div>
    <div class="contentblock board_layout" :data-block-id="bdata.paperBlockId">
      <ContentBlockCreatorInfo
        :bdata ="bdata"
        :blockModDate="blockModDate"
        :blockRegDate="blockRegDate"
        :blockModUserName="blockModUserName"
        :blockRegUserName="blockRegUserName">
      </ContentBlockCreatorInfo>
      <!-- [블럭 잠금 표시부분] -->
      <div class="editor">
        <div class="name">
          {{ defaultLanguage.indexOf('ko') != -1 ? bdata.blockLockName : 
            bdata.blockLockNameEn != null ? bdata.blockLockNameEn : bdata.blockLockName }}</div>
        <div class="lock">{{$i18nUtil.trans("message.ContentBlockTypeContent.001","잠김")}}</div>
      </div>
      <!-- /[블럭 잠금 표시부분] -->
      <div class="eidtbox-ty1 attachfile_box">
        <div
          class="hover_box"
          :class="
            (decisionState === 1 ? 'todo_wrap_write ' : '') +
            (decisionState === 2 ? 'todo_wrap_view ' : '')
          "
        >
          <!-- [rowbox] -->
          <div class="hover_inner">
            <!-- [드래그 핸들] -->
            <!-- 보이는 드래그 핸들 -->
            <div v-if="decisionState === 2" class="move"></div>
            <!-- 실제 이벤트 드래그 핸들 -->
            <div
              v-if="decisionState === 2"
              class="block_handle"
              ref="dragHandle"
              :data-block-id="bdata.paperBlockId"
              :transfer-data="bdata.paperBlockId"
              @mousedown="dragBlockState(1)"
              @mouseup="dragBlockState(0)"
              @touchstart="dragBlockState(1)"
              @touchend="dragBlockState(0)"
            >
              &nbsp;
            </div>
            <!-- /[드래그 핸들] -->
            <!-- [의사결정 블럭] -->
            <template
              v-if="decisionState === 1 && userInfo.userId === bdata.regUserId"
            >
              <!-- 작성자만 보여지는 의사결정 최초 작성 블럭 -->
              <!-- 의사결정 등록 [BDS_081] -->
              <div class="top">
                <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">{{$i18nUtil.trans("entity.decision","의사결정")}}</div>
                <span class="status-txt">{{$i18nUtil.trans("entity.decision.status.proceeding","승인 전")}}</span>
                <div class="dividing_line_ty2"></div>
                <div class="dropdown ty1">
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        ref="memberSearchBtn"
                        @click="showMemberSearch"
                        v-bind="attrs"
                        v-on="on"
                        >{{ deciTarget }}</v-btn
                      >
                    </template>
                    <div ref="memberSearchList" class="dropdown-list">
                      <div class="search top">
                        <form action="" onsubmit="return false;">
                          <div class="search_ty1">
                            <input
                              type="text"
                              @focus="$event.target.placeholder = ''"
                              @focusout="$event.target.placeholder =$i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')"
                              :placeholder="$i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')"
                              @keyup.enter="searchByKeyword"
                              @keydown="searchByKeyword"
                              @input="searchByKeyword"
                            />
                            <button
                              type="reset"
                              class="btn_search"
                              @click="clickMemberSearchBtn"
                            >
                              {{$i18nUtil.trans("search.039","검색")}}
                            </button>
                          </div>
                        </form>
                      </div>
                      <div class="member-call-box search">
                        <div class="scroll">
                          <div class="nodata" v-if="!isSearch">
                            <div class="txt" v-html="$i18nUtil.trans('message.BoardOpinionModal.006','결정자 지정하여<br />의사결정을 요청해보세요.')">
                            </div>
                          </div>
                          <dl v-if="isSearch">
                            <dt v-if="searchMemberList.length != 0">멤버 검색 결과</dt>
                            <dd>
                              <div class="nodata" v-if="searchMemberList.length == 0"
                                   v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')"> 
                              </div>
                              <ul class="member-list" v-else>
                                <li
                                  v-for="(item, index) in searchMemberList"
                                  :key="'member' + index"
                                  :data-user-id="item.userId"
                                  :data-user-name="item.userName"
                                  @click="
                                    opiSetuserId(item.userId, item.userName)
                                  "
                                >
                                  <div
                                    class="img user-photo"
                                    :data-user-id="item.userId"
                                  >
                                    <img
                                      src="@/assets/img/no-avatar.png"
                                      alt=""
                                    />
                                  </div>
                                  <b class="name ell-singleline"
                                    >{{ item.userName }}
                                    <span>{{ item.jobPositionName }}</span></b
                                  >
                                  <span class="team ell-singleline"
                                    >{{ item.companyName }} /
                                    {{
                                      item.isExternalUser
                                        ? item.partnerName
                                        : item.deptName
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </dd>
                          </dl>
                          <dl v-if="isSearch && autoInvite == 'false'">
                            <dt>
                              {{$i18nUtil.trans("message.ContentBlockTypeDecision.001","찾으시는 멤버가 없으면, 멤버로 추가해 주세요.")}}
                            </dt>
                          </dl>
                          <dl
                            v-if="isSearch && autoInvite == 'true'
                                  && searchUserList.length > 0 && paperInfo.internalUserYn">
                            <dt v-html="$i18nUtil.trans('search.050','멤버 외 검색 결과 (등록 완료 시 멤버로 자동 추가됩니다.)')"></dt>
                            <dd>
                              <div
                                class="nodata"
                                v-if="searchNoMemberList.length == 0"
                                v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')"
                              >
                              </div>
                              <ul class="member-list" v-else>
                                <li
                                  v-for="(item, index) in searchNoMemberList"
                                  :key="'noMember' + index"
                                  :data-user-id="item.userId"
                                  :data-user-name="item.userName"
                                  @click="
                                    opiSetuserId(item.userId, item.userName)
                                  "
                                >
                                  <div
                                    class="img user-photo"
                                    :data-user-id="item.userId"
                                  >
                                    <img
                                      src="@/assets/img/no-avatar.png"
                                      alt=""
                                    />
                                  </div>
                                  <b class="name ell-singleline"
                                    >{{ item.userName }}
                                    <span>{{ item.jobPositionName }}</span></b
                                  >
                                  <span class="team ell-singleline"
                                    >{{ item.companyName }} /
                                    {{
                                      item.isExternalUser
                                        ? item.partnerName
                                        : item.deptName
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </dd>
                          </dl>
                        </div>
                      </div>
                      <div class="search bottom">
                        <form action="" onsubmit="return false;">
                          <div class="search_ty1">
                            <input
                              type="text"
                              @focus="$event.target.placeholder = ''"
                              @focusout="$event.target.placeholder =$i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')"
                              :placeholder="$i18nUtil.trans('message.placeholder.contactName','담당자 이름으로 검색')"
                              @keyup.enter="searchByKeyword"
                              @keydown="searchByKeyword"
                              @input="searchByKeyword"
                            />
                            <button
                              type="reset"
                              class="btn_search"
                              @click="clickMemberSearchBtn"
                            >
                              {{$i18nUtil.trans("search.039","검색")}}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </v-menu>
                </div>
                <div class="right">
                  <div class="date">
                    {{ this.$moment().format("YYYY.MM.DD") }}
                  </div>
                </div>
              </div>
              <div class="write_grp clear">
                <div class="write fl">
                  <form action="">
                    <div class="input-box">
                      <textarea
                        type="text"
                        required
                        @focus="$event.target.placeholder = ''"
                        @focusout="$event.target.placeholder =$i18nUtil.trans('message.ContentBlockTypeDecision.002','의사결정 요청 내용 등록 후, 내용을 클릭하면 파일을 첨부할 수 있습니다.')"
                        :placeholder="$i18nUtil.trans('message.ContentBlockTypeDecision.002','의사결정 요청 내용 등록 후, 내용을 클릭하면 파일을 첨부할 수 있습니다.')"
                        maxlength="501"
                        @input="errorContents = false"
                        v-model="deciEditorData.contents"
                      />
                      <button type="reset" class="input-txt-del">
                        {{$i18nUtil.trans("message.HtagList.004","입력 삭제")}}
                      </button>
                      <div
                        class="character-limit_box txtr"
                        v-if="
                          deciEditorData.contents != null &&
                          deciEditorData.contents.length > 500
                        "
                      >
                        <span class="error"
                          >{{$i18nUtil.trans("message.exceed.characters","입력 가능한 글자수를 초과하였습니다.")}}</span>
                        <span class="count"
                          >(<b>{{ deciEditorData.contents.length }}</b
                          >/500)</span
                        >
                      </div>
                      <div class="error" v-if="errorContents">
                        {{$i18nUtil.trans("message.ContentBlockTypeDecision.003","의사결정 요청 내용을 입력해주세요.")}}
                      </div>
                    </div>
                  </form>
                </div>
                <div class="btn_box fr">
                  <button
                    type="button"
                    class="btn-txt-primary"
                    @click="deleteFileBlock()"
                  >
                    {{$i18nUtil.trans("button.cancel","취소")}}
                  </button>
                  <button
                    type="button"
                    class="btn-txt-primary black"
                    @click="opinionSubmitForm"
                  >
                    {{$i18nUtil.trans("button.register","등록")}}
                  </button>
                </div>
              </div>
              <!-- /의사결정 등록 [BDS_081] -->
              <!-- /작성자만 보여지는 의사결정 최초 작성 블럭 -->
            </template>
            <template
              v-else-if="
                decisionState === 1 && userInfo.userId != bdata.regUserId
              "
            >
              <!-- 최초 생성후 작성자가 아니면 보여지는블럭 -->
              <!-- 임의작성됨 -->
              <div class="top loading-box">
                <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">
                  {{$i18nUtil.trans("entity.decision","의사결정")}}
                </div>
                <div class="loader_wrap">
                  <div class="loader">Loading...</div>
                  <span>{{ $i18nUtil.trans("message.ContentBlockTypeDecision.010","보드멤버가 의사결정을 작성중입니다.") }}</span>
                </div>
              </div>
              <!-- /최초 생성후 작성자가 아니면 보여지는블럭 -->
            </template>
            <template v-else-if="decisionState === 2">
              <!-- 의사결정 [BDS_082] S -->
              <div class="top">
                <div class="label-fin" :class="$i18nUtil.getLanguage() === 'en' ? 'enCss' : '' ">{{$i18nUtil.trans("entity.decision","의사결정")}}</div>
                <span class="status-txt" v-if="items.status == 'APPL'"
                  >{{$i18nUtil.trans("entity.decision.status.proceeding","승인 전")}}</span
                >
                <span class="status-txt" v-if="items.status == 'RETURN'"
                  >{{$i18nUtil.trans("entity.decision.status.reject","반려")}}</span
                >
                <span class="status-txt" v-if="items.status == 'APROVAL'"
                  >{{$i18nUtil.trans("entity.decision.status.approval","승인")}}</span
                >
                <div class="dividing_line_ty2" v-if="fileCount > 0"></div>
                <div class="ico_attachfile" v-if="fileCount > 0">{{$i18nUtil.trans("entity.file","첨부파일")}}</div>
                <div
                  class="view multi-ellipsis"
                  @click="openModal2(items)"
                  v-html="items.contents.split('\n').join('<br />')"
                ></div>
                <div class="right">
                  <div class="date" v-if="items.status == 'APPL'">
                    {{ $moment(items.regDate).format("YYYY.MM.DD") }}
                  </div>
                  <div class="date" v-else>
                    {{ $moment(items.deciDate).format("YYYY.MM.DD") }}
                  </div>
                  <div class="re-de">
                    <div class="re">
                      <div class="droplayer relative">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="permit_everyone"
                              v-bind="attrs"
                              v-on="on"
                              ><div
                                class="member"
                                :data-user-id="items.regUserId"
                              >
                                <img src="@/assets/img/no-avatar.png" alt="" />
                                {{ items.regUserName }}
                              </div></v-btn
                            >
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip :userId="items.regUserId" />
                          </div>
                        </v-menu>
                      </div>
                    </div>
                    <div class="division"></div>
                    <div class="de">
                      <div class="droplayer relative">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              class="permit_everyone"
                              v-bind="attrs"
                              v-on="on"
                              ><div class="member" :data-user-id="items.userId">
                                <img src="@/assets/img/no-avatar.png" alt="" />
                                {{ items.userName }}
                              </div></v-btn
                            >
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip :userId="items.userId" />
                          </div>
                        </v-menu>
                      </div>
                    </div>
                  </div>
                  <div
                    class="droplayer icon more large right nosel"
                  >
                    <!-- v-if="items.regUserId == userInfo.userId" -->
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="permit_everyone" v-bind="attrs" v-on="on"
                          >{{$i18nUtil.trans("button.more","더보기")}}</v-btn
                        >
                      </template>
                      <div class="dropdown-list">
                        <div class="dropdown-list-item">
                          <div class="tit">
                            <button type="button" @click="deldeci(items)">
                              {{$i18nUtil.trans("button.delete.decision","의사결정 삭제")}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </v-menu>
                  </div>
                </div>
              </div>
              <!-- /의사결정 [BDS_082] S -->
            </template>
            <!-- /[의사결정 블럭] -->
            <!-- [의견 영역] -->
            <div
              v-if="decisionState === 2"
              ref="buttonComment"
              class="hover_comment"
              :class="
                (commentCount ? ' display-block' : '') +
                (blockInfo.commentSelectId === bdata.paperBlockId
                  ? ' display-block active'
                  : '')
              "
            >
              <button
                type="button"
                class="permit_everyone"
                @click="viewComment"
              >
                {{ !commentCount ? "" : commentCount }}
              </button>
            </div>
            <!-- /[의견 영역] -->
          </div>
          <!-- /[rowbox] -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lodash from "lodash";
import { mapActions, mapState } from "vuex";
import Datepicker from "vuejs-datepicker";

import EventBus from "@/js/eventbus/eventBus";
import MyModalU from "../opinion/BoardOpinionModalU.vue";
import MyModal from "../opinion/BoardOpinionModal.vue";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import ContentBlockCreatorInfo from "./ContentBlockCreatorInfo";

export default {
  components: {
    Datepicker,
    UserTooltip,
    ContentBlockCreatorInfo,
  },
  props: {
    paperInfo: Object,
    blockInfo: Object,
    boardMemberInfo: Object,
    boardSection: Array,
    bdata: Object,
    transmitter: Object,
    userInfo: Object,
    paperBlockIdList: Array,
    paperBlockMap: Object,
    boardUtil: Object,
    context: Object,
    editorData: Object,
    memberSelector: Object,
  },
  data() {
    return {
      autoInvite: localStorage.getItem("autoInvite"),
      ellipsisTimer: null,
      searchKeyword: "",
      isSearch: false,
      pdata: this.bdata,
      editable: false,
      keepInBounds: true,
      loading: true,
      messageList: [],
      files: [],
      fileUploadType: null,
      state: {
        memberIndex: [0],
      },
      commentCount: this.blockInfo.commentCounts[this.bdata.paperBlockId],
      opinionEditorData: {
        deciName: null,
        paperId: String(this.paperInfo.paperId),
        contents: null,
        paperFileId: null,
        userId: null,
        fileName: null,
      },
      members: this.boardMemberInfo.userList,
      opinionUpfile: {
        groupId: String(this.paperInfo.groupId),
        paperId: String(this.paperInfo.paperId),
        files: [],
      },
      opiniondata: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null,
      },
      files: [],
      udfform: {
        paperFileId: "",
        seq: "",
        fileId: "",
        fileName: "",
      },
      opiTargetName: this.$i18nUtil.trans("message.ContentBlockTypeDecision.004","결정자 선택"),

      deciEditorData: {
        deciName: null,
        paperId: String(this.paperInfo.paperId),
        contents: null,
        userId: null,
        paperBlockId: String(this.bdata.paperBlockId),
      },
      opinionUpfile: {
        groupId: String(this.paperInfo.groupId),
        paperId: String(this.paperInfo.paperId),
        files: [],
      },
      opiniondata: {
        obj: this,
        url: null,
        header: null,
        sendType: null,
        frm: null,
      },
      udfform: {
        paperFileId: "",
        seq: "",
        fileId: "",
        fileName: "",
      },
      files: [],
      searchUserList: [],
      searchMemberList: [],
      searchNoMemberList: [],
      items: {},
      deciTarget: this.$i18nUtil.trans("message.ContentBlockTypeDecision.004","결정자 선택"),
      errorContents: false,
      fileCount: 0,

      /* 의사결정 상태 TODO: 다른 이름으로 사용할수 있도록 조치 */
      // 디폴트 : 0
      decisionState: 0,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },

      defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko',

      blockModDate : '',
      blockRegDate: '',
      blockModUserName:'',
      blockRegUserName:'',
    };
  },
  created() {
    this.context.eventBusProc(this);
    this.context.initContentBlock(this);
    this.getDeciToBlock();
    EventBus.$off("DecisionBlockWidgetRefresh");

    EventBus.$on("DecisionBlockWidgetRefresh", (payload) => {
      if (payload === this.bdata.paperBlockId) {
        this.contentBlockAPI("updateBlock");
      }
    });
  },
  mounted() {
    this.multiElipsis(2);
    let self = this;
    this.transmitter.subscribers[self.bdata.paperBlockId] = {
      subscribe: function (command, data, error) {
        self.stompEditorSubscribe(command, data, error);
      },
    };
    this.onConnected();
    this.renderCompleted(function(){
      self.$emit("blockMatch");
    });
  },
  computed:{
    ...mapState("noti", ["notiBoardBlockId"]),
  },
  updated() {
    let memberList = this.$el.querySelectorAll("div.member");
    if (memberList) {
      for (let inx = 0; inx < memberList.length; inx++) {
        let elem = memberList[inx];
        let userId = elem.getAttribute("data-user-id");
        let img = elem.querySelector("img");
        this.HW_GET_USER_PHOTO({ img, userId });
      }
    }
    let list = this.$el.querySelectorAll("div.img.user-photo");
    if (list) {
      for (let inx = 0; inx < list.length; inx++) {
        let elem = list[inx];
        let userId = elem.getAttribute("data-user-id");
        let img = elem.querySelector("img");
        this.HW_GET_USER_PHOTO({ img, userId });
      }
    }
  },
  beforeDestroy() {
    delete this.transmitter.subscribers[this.bdata.paperBlockId];
  },
  watch: {},
  methods: {
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("evdControl", ["SIMPLE_KBD_SCROLL"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO", "CHECK_AND_LAUNCH"]),
    stompEditorSubscribe(command, bdata, error) {
      if (command === "content") {
        if (
          bdata.paperId === this.paperInfo.paperId &&
          bdata.paperBlockId === this.bdata.paperBlockId
        ) {
          if(bdata.modDate != null){
            this.blockModDate = bdata.modDate;
            this.blockModUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.blockLockNameEn !== null ? bdata.blockLockNameEn : bdata.blockLockName;
          }
          if(bdata.regDate != null){
            this.blockRegDate = bdata.regDate;
            this.blockRegUserName = this.$i18nUtil.getLanguage() === 'en' && bdata.regUserNameEn !== null ? bdata.regUserNameEn : bdata.regUserName;
          }
          this.getDeciToBlock();
          return true;
        }
      }
      return false;
    },
    /* synap 파일 뷰어 호출 */
    callFileViewer(param) {
      this.$router.push(
        "/general/viewer/" + param.groupId + "/" + param.fileId
      );
    },
    deleteFileBlock() {
      let self = this;
      self.deleteBlock({
        callback(res) {
          if (res && res.data && !res.data.errorCode) {
            self.boardUtil.removeBlockData(self.bdata.paperBlockId);
            let toastMsg = self.$i18nUtil.trans("TB071");
            self.toast(toastMsg);
          }
        },
      });
    },
    opinionCreate() {
      /* 의사결정 위젯을 띄운다 */
      let el = this.$refs.opinionForm;
      el.classList.toggle("hidden");
      console.log("show opinion create form");
    },

    opinionSubmitForm() {
      const self = this;
      if (
        this.deciEditorData.userId == null ||
        this.deciEditorData.userId == ""
      ) {
        this.showAlertDialog(this.$i18nUtil.trans("AB057"), null, {
          width: "440px",
        });
        return;
      } else if (this.deciEditorData.userId == this.userInfo.userId) {
        this.showAlertDialog(this.$i18nUtil.trans("AB078"), null, {
          width: "440px",
        });
        return;
      }
      if (
        this.deciEditorData.contents == null ||
        this.deciEditorData.contents == ""
      ) {
        this.errorContents = true;
        return;
      } else if (this.deciEditorData.contents.length > 501) {
        return;
      }
      // this.deciEditorData.deciName = this.deciEditorData.contents;
      let _obj = this;
      let makingurl = "/api/copaper/decision/making";
      let makingparam = { makingData: this.deciEditorData };
      this.context.showProgress(60000);
      this.$axios.post(makingurl, makingparam).then((response) => {
        setTimeout(this.context.hideProgress, 1000);
        EventBus.$emit("outputBoardInsert", this.bdata.paperBlockId);
        EventBus.$emit("DecisionBlockWidgetRefresh", this.bdata.paperBlockId);
        EventBus.$emit("updatePaperUser");
        // EventBus.$emit("refreshPerDeciNewPage");
        this.getDeciToBlock();
        // this.closeDeciBlock();
      });
    },
    opiSetuserId(param1, param2) {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/checkBlockPolicy";
      reqData.method = "post";
      reqData.params = {
        paperId: this.paperInfo.paperId,
        userId: param1,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode) {
          console.log(response.errorCode);
        } else {
          if(response.result.checkPolicy && response.result.checkPolicy.length >0 ){
            let checkPolicy = "";
            response.result.checkPolicy.forEach((res)=>{
              checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
            })
            obj.showAlertDialog(obj.$i18nUtil.trans("AB112",{ checkPolicy: checkPolicy}));
            return;
          }

          if (response.result) {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.member.blocked","정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.");
            obj.showToast(obj.toastInfo);
          } else {
            obj.deciEditorData.userId = param1;
            obj.deciTarget = param2;

            obj.searchKeyword = "";
            obj.searchUserList = [];
            obj.searchMemberList = [];
            obj.searchNoMemberList = [];
            obj.isSearch = false;
          }
        }
      });

      let element = this.$el.querySelectorAll(
        ".v-btn.v-btn--contained.theme--light.v-size--default"
      );
      for (let i = 0; i < element.length; i++) {
        if (element[i].getAttribute("aria-expanded")) {
          element[i].click();
        }
      }

      // document
      //   .getElementById("deciDt-" + this.bdata.paperBlockId)
      //   .classList.toggle("active");
    },
    // closeDeciBlock() {
    //   EventBus.$emit("closeDeciBlock", this.bdata.paperBlockId);
    // },
    getDeciToBlock() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/getDeci";
      reqData.method = "post";
      reqData.params = {
        paperId: this.paperInfo.paperId,
        paperBlockId: this.bdata.paperBlockId,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode) {
          console.log(response.errorCode);
        }
        let data = response.result;
        
        this.items = data;
        if (this.items != null) {
          this.decisionState = 2;
          this.decisionFileCount();

          // locale에 따른 사용자명 영문 처리
          if(this.$i18nUtil.getLanguage() === 'ko') {

          }else{
            this.items.regUserName = this.items.regUserNameEn != null ? this.items.regUserNameEn : this.items.regUserName;
            this.items.userName = this.items.userNameEn != null ? this.items.userNameEn : this.items.userName;
          }

        } else {
          this.decisionState = 1;
        }
      });
    },
    decisionFileCount() {
      let obj = this;
      let reqData = {};
      reqData.url = "/api/copaper/decision/decisionFileCount";
      reqData.method = "post";
      reqData.params = {
        deciId: this.items.deciId,
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
        if (response.errorCode) {
          console.log("/decisionFileCount errorCode", response.errorCode);
        }
        obj.fileCount = response.result;
      });
    },
    searchByKeyword(event) {
      let obj = this;
      let memberSearch = obj.$refs.memberSearchList.parentNode;
      obj.SIMPLE_KBD_SCROLL({
        event: event,
        index: obj.state.memberIndex,
        offsetTop: memberSearch.classList.contains("search_list_reverse")
          ? 0
          : -80,
        root: obj.$el,
        itemQuery: ".member-call-box .scroll li",
        scrollQuery: ".member-call-box .scroll",
        pointerClass: "selected",
        onSelect(e, inx, elem) {
          // console.log("SELECTED:", inx, elem);
          if (elem) {
            let userId = elem.getAttribute("data-user-id");
            let userName = elem.getAttribute("data-user-name");
            event.target.value = "";
            obj.opiSetuserId(userId, userName);
          }
        },
        onCancel(e) {
          lodash.debounce(() => {
            // console.log("CANCELED!");
            if (!event.target.value) {
              obj.$refs.memberSearchBtn.$el.click();
            }
            event.target.value = "";
            obj.searchByKeywordWrapper(e);
          }, 10)();
        },
        callback(e, fncScroll) {
          lodash.debounce(() => {
            // console.log("SEARCHING..", e);
            obj.searchByKeywordWrapper(e, fncScroll);
          }, 500)();
        },
      });
    },
    searchByKeywordWrapper(event, fncScroll) {
      let obj = this;
      this.searchKeyword = event.target.value;
      if (this.searchKeyword.length > 1) {
        this.isSearch = true;
        let reqData = {};
        reqData.req = {
          searchKeyword: this.searchKeyword,
        };
        reqData.url = "/api/auth/org/searchByUserName";
        reqData.method = "post";

        obj
          .COWORK_REST_ACTION(reqData)
          .then(function (data) {
            obj.searchMemberList = [];
            obj.searchNoMemberList = [];
            obj.searchUserList = data.result;
            obj.searchUserList.forEach((item) => {
              let memberCheck = false;
              obj.boardMemberInfo.userList.forEach((value) => {
                if (value.userId == item.userId) {
                  memberCheck = true;
                }
              });
              if (memberCheck) {
                obj.searchMemberList.push(item);
              } else {
                obj.searchNoMemberList.push(item);
              }
              if (fncScroll) {
                obj.state.memberIndex[0] = 0;
                fncScroll(obj.state.memberIndex);
              }
            });
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        this.isSearch = false;
      }
    },
    clickMemberSearchBtn() {
      if (this.searchKeyword.length > 0) {
        this.isSearch = false;
        this.searchKeyword = "";
      }
    },
    deldeci(param) {
      if (param.confirm == 1) {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.Noti.001","알림"),
          width: "400px",
          // height: "166px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AB067"),
          button: this.$i18nUtil.trans("button.confirm","확인"),
          component: Dialog,
        };
        this.showModal(modalInfo);
        return;
      } else {
        this.showConfirmDialog(
          { width: "400px" },
          this.$i18nUtil.trans("title.Noti.001","알림"),
          this.$i18nUtil.trans("AG001"),
          this.$i18nUtil.trans("button.delete","삭제"),
          this.dialogConfirm,
          param,
          this.$i18nUtil.trans("button.cancel","취소")
        );
        //   let obj = this;
        //   let outputdelete = {
        //     url: "/api/copaper/decision/deldeci",
        //     method: "post",
        //     params: param,
        //   };
        //   obj.COWORK_REST_SIMPLE_ACTION(outputdelete).then((response) => {
        //     // this.getDeciToBlock();
        //     this.deleteFileBlock();
        //   });
      }
    },
    dialogConfirm(param) {
      let obj = this;
      /* 권한체크 RW = permission 2 */
      if (obj.paperInfo.permission > 1) {
        let outputdelete = {
          url: "/api/copaper/decision/deldeci",
          method: "post",
          params: param.modalParam,
        };
        obj.COWORK_REST_SIMPLE_ACTION(outputdelete).then((response) => {
          if (response.errorCode == null) {
            obj.deleteFileBlock();
          } 
          // if (response.errorCode == "NOT_AUTHORIZED") {
          //   obj.toastInfo.message = obj.$i18nUtil.trans("TB056");
          //   obj.showToast(obj.toastInfo);
          // } else {
          // obj.deleteFileBlock();
          // 의사결정 삭제 시, 토스트 두 건 발생으로 주석처리 > deleteFileBlock() 내에서 토스트 알림 발생되고 있음
          // obj.toastInfo.message = obj.$i18nUtil.trans("TB071");
          // obj.showToast(obj.toastInfo);
          // }
          // this.getDeciToBlock();
        });
      } else {
        /* 권한이 없습니다 */
        let toastMsg = this.$i18nUtil.trans("TB044");
        this.toast(toastMsg);
      }
    },
    openModal2(param) {
      if (param.userId === this.userInfo.userId) {
        const modalInfo = {
          name: "BoardOpinionModalU",
          obj: this.$modal,
          component: MyModalU,
          width: "800px",
          // height: "665px",
          item: param,
          onclose: () => {
            this.paperBlockContentRequest([this.bdata.paperBlockId], {}, false);
            // this.contentBlockAPI("updateBlock");
          }
        };
        this.showModal(modalInfo);
      } else {
        const modalInfo = {
          obj: this.$modal,
          component: MyModal,
          width: "800px",
          // height: "665px",
          item: param,
          paperInfo: this.paperInfo,
          onclose: () => {
            this.paperBlockContentRequest([this.bdata.paperBlockId], {}, false);
            // this.contentBlockAPI("updateBlock");
          }
        };
        this.showModal(modalInfo);
      }
    },
    /* 협업멤버 선택 */
    selectBoardUser(data, index) {
      if (index < 0) {
        return;
      }
      let contents = "";
      if (this.paperInfo.categoryInfo.section == "CFRC") {
        contents =
          this.$i18nUtil.trans("message.ContentBlockTypeDecision.012","담당자 지정시 보드의 멤버로 추가됩니다. 과제의 멤버로도 추가하시겠습니까?");
      } else {
        contents = this.$i18nUtil.trans("AB048");
      }
      const modalInfo = {
        title: this.$i18nUtil.trans("title.Noti.001","알림"),
        width: "400px",
        height: "166px",
        obj: this.$modal,
        contents: contents,
        button: this.$i18nUtil.trans("button.add","추가"),
        subButton: this.$i18nUtil.trans("button.dialog.no","아니오"),
        dialogType: "addMember",
        data: data,
        component: Dialog,
      };
      this.showModal(modalInfo);
    },
    searchNull() {
      document.getElementById(
        "searchByKeyword_" + this.deciEditorData.paperBlockId
      ).value = "";
    },
    multiElipsis(ellipsisLine) {
      if (this.ellipsisTimer) {
        clearTimeout(this.ellipsisTimer);
      }

      this.ellipsisTimer = setTimeout(function () {
        if ($(".multi-ellipsis").length > 0) {
          var omle = $(".multi-ellipsis");
          var $txtR = $("<div class='txtEllipsis'></div>");
          var $body = $("body");
          omle.each(function (idx) {
            var _this = $(this);
            var orinalWidth = $(this).width();
            var txtOmle = _this.text();

            $txtR.text(txtOmle);
            $body.append($txtR);

            if ($txtR.width() >= orinalWidth * 1.2) {
              _this.addClass("no-ellipsis");
            } else {
              _this.removeClass("no-ellipsis");
            }
          });
        }
      }, 250);

      setTimeout(function () {
        $(".txtEllipsis").remove();
      }, 1000);
      // const obj = this;
      // $(window).on("load resize", function () {
      //   obj.multiElipsis(2);
      // });
    },
    showMemberSearch(e) {
      let self = this;
      self.CHECK_AND_LAUNCH({
        check(ctx) {
          return (ctx.ret = self.$refs.memberSearchList);
        },
        launch(ctx) {
          let wscrollTop = window.scrollY || window.pageYOffset;
          let wHeight = window.innerHeight;
          let memberSearch = ctx.ret.parentNode;
          // console.log("TOP:", self.$el.offsetTop, wscrollTop, wHeight, wHeight - self.$el.offsetTop + wscrollTop);
          if (wHeight - self.$el.offsetTop + wscrollTop > 380) {
            memberSearch.classList.add("search_list_normal");
            memberSearch.classList.remove("search_list_reverse");
          } else {
            memberSearch.classList.remove("search_list_normal");
            memberSearch.classList.add("search_list_reverse");
          }
        },
      });
    },
  },
};
</script>

<!-- 지역스타일 지정 -->
<style scoped>
.todo_wrap_write .loader_wrap {
  position: relative;
  margin-right: 10px;
  top: -8px;
}
.todo_wrap_write .loader_wrap .loader {
  margin-right: 10px;
}
.errorBlock {
  background-color: rgb(245, 205, 205);
}

.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  min-height: 23px;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}

[class*="todo_wrap"] .enCss {
    width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/board/editor/ContentBlockTypeDecision.vue